module.exports = __webpack_public_path__ + "static/media/mills.854ed454.svg";